export const RECEIVED_MESSAGE = "RECEIVED_MESSAGE";
export const SET_HISTORY = "SET_HISTORY";
export const SET_READY_STATE = "SET_READY_STATE";
export const SET_MESSAGE = "SET_MESSAGE"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE"
export const SET_LIMIT = "SET_LIMIT"
